import React__default from 'react';
import { useLink } from '@grandvisionhq/frk-routing';
import { useFeatureToggles } from '@grandvisionhq/state';
import { getProductKeyFromCTType, sanitizeStringForUrl } from '@grandvisionhq/utils';
import { useProductData } from '../../../../context/product-context-hooks.js';
import { isContactLensVariant } from '../../../../types/typeguards.js';

const useBrandLink = ()=>{
    const { activeVariant , product: { brandName , productType  } ,  } = useProductData();
    const { isSubcategoryPlpLinkingDisabled  } = useFeatureToggles();
    const link = useLink({
        route: 'products.list',
        params: {
            type: getProductKeyFromCTType(productType),
            subCategory: sanitizeStringForUrl(brandName)
        }
    });
    const brandLink = React__default.useMemo(()=>{
        if (isSubcategoryPlpLinkingDisabled) return undefined;
        if (isContactLensVariant(activeVariant)) return undefined;
        if (!(link === null || link === void 0 ? void 0 : link.href)) return undefined;
        return link.href;
    }, [
        activeVariant,
        isSubcategoryPlpLinkingDisabled,
        link
    ]);
    return brandLink;
};

export { useBrandLink };
//# sourceMappingURL=use-brand-link.js.map
